<template>
    <div>
        <div style="text-align:center; font-size: 17px;text-align:left;color:#5b6c7f;margin-bottom:20px;">
            <!-- <div class="box-header with-border">
              <h3 class="box-title">{{$t('documentation.title')}}</h3>
            </div> -->
            <b>{{$t('documentation.title')}}</b>

            <lte-button
              style ="float:right;"
              type="btn btn-primary"
              right_icon="fa fa-plus"
              @click="callback($event)"
            >
              {{$t('user.addnew')}}
            </lte-button>
            <!-- <div class="box-body">
              <div>
                <a href="../static/pdfs/CONASI-HOME_guideline.pdf" target="_blank">CONASI-HOME Guideline</a>
              </div>
            </div> -->
        </div>
        <lte-table
              :hdBackground="hdBackground"
              :data="gridDocumentDataList"
              :columns="gridColumns"
              :containLink="true"
              search_filter="left-search"
              :useFilter="useFilter"
              @actions="crudActions"
              :actions="actions"
        ></lte-table>
        <lte-modal
          v-show="isModalVisible"
          @onConfirm="onConfirm"
          @close="closeModal"
          v-for="obj in objModal"
          :key="obj.id"
          :item="obj"
        ></lte-modal>
        <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
        <loading :active.sync="isLoading" :can-cancel="false" color="#1E90FF"></loading>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { LTEActionTypeEnum } from '@/components/LTEEnum'
import LTEButton from "@/components/LTEButton.vue";
import LTETable from "@/components/LTETable.vue";
import LTEModal from "@/components/LTEModal.vue";
import Loading from "vue-loading-overlay";
import LTECoreAlert from "@/components/LTESnackBar.vue";
// import utils from '@/lib/utils'

export default {
  name: 'DocumentaionList',
  data () {
    return {
      buttonName: "danger",
      labelName: "Name",
      gridDocumentDataList: [],
      useFilter:false,
      gridColumns: [
        { text: "common.nonumber", isHidden: true},
        { text: "documentation.project_name", isHidden:true },
        // { text: "documentation.name", isHidden: true},
        { text: "documentation.url", isHidden: true},
      ],
      hdBackground: {
          backgroundColor: '#4b646f',
          color: 'white',
          border:'1px solid white'
      },
      actions: ["common.modify","common.delete"],
      originalRecordData:[],
      isModalVisible: false,
      objModal: [
        {
          title: 'documentation.inform_modal[0].title',
          body: 'documentation.inform_modal[0].del_body',
          buttonNo: 'documentation.inform_modal[0].modal_btn[0].cancel',
          buttonYes: 'documentation.inform_modal[0].modal_btn[0].confirm',
          styleType:"default"
        }
      ],
      isLoading: false,
    }
  },
  watch:{
    GET_DOCUMENT_DATA:function(){
      this.gridDocumentDataList=[]
      this.GET_DOCUMENT_DATA.forEach((row,i) => {
        let nonumber=i+1;
        let name=row.name;
        let url=row.url;
        let project_id=row.project.project_name;
        let id=row.id
        let data={
          "common.nonumber": nonumber,
          "documentation.name": name,
          "documentation.url": url,
          "documentation.project_name": project_id,
          "id":id
        }
        this.gridDocumentDataList.push(data);
      });
    },
  },
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR",
      "GET_DOCUMENT_DATA"
    ]),
    role: function () {
      return this.GET_ACCOUNT_DATA.id;
    }
  },
  methods: {
    ...mapActions([
      "ERROR_TOAST",
      "SUCCESS_TOAST",
      "GET_DOCUMENT_LIST",
      "DELETE_DOCUMENT"
    ]),
    callback: function() {
      this.$router.push({
        name: "DocumentationAdd",
        params: {
          id: 0
        },
      });
    },
    crudActions:function(recordData,actionsType,isModalVisible){
      if(actionsType==LTEActionTypeEnum.MODIFY)
      {
      this.$router.push({
          name: "DocumentationAdd",
          params: {
            id: recordData.id
          }
        })
      }else {
        this.originalRecordData = recordData;
        this.isModalVisible = isModalVisible;
      }
    },
    onConfirm: function() {
      this.isModalVisible = false;
      this.DELETE_DOCUMENT(this.originalRecordData)
        .then(
          function() {
            this.GET_DOCUMENT_LIST();
            this.SUCCESS_TOAST();
          }.bind(this)
        )
        .catch(
          function() {
            this.ERROR_TOAST();
          }.bind(this)
        );
    },
    closeModal() {
      this.isModalVisible = false;
    }
  },
  created() {

  },
  mounted() {
    this.GET_DOCUMENT_LIST();
  },
  components: {
    "lte-button": LTEButton,
    "lte-table": LTETable,
    "lte-modal": LTEModal,
    "loading": Loading,
    "lte-core-alert": LTECoreAlert,

    // "lte-core-alert": LTECoreAlert,
    // pdf
  }
}

</script>



// WEBPACK FOOTER //
// src/views/Documentation/DocumentationList.vue